export const COLOR_PLACEHOLDER = "Add a hex code";
export const URL_PLACEHOLDER = "Add an ad targeting slug";
export const DEEP_DIVE_SERIES_PLACEHOLDER = "Select a Deep Dive series";
export const DEEP_DIVE_UNSAVED_CHANGES_MESSAGE =
  "Are you sure you want to leave? You have unsaved changes that will be lost.";

export const DEEP_DIVE_EDITOR_LINKS = [
  {
    required: true,
    text: "Content",
    to: "content",
  },
  {
    required: true,
    text: "Metadata",
    to: "metadata",
  },
];
